// extracted by mini-css-extract-plugin
export var active = "_am-b";
export var activeIndicator = "_am-6";
export var animate = "_am-a";
export var disabled = "_am-c";
export var flat = "_am-1";
export var fullWidth = "_am-3";
export var lg = "_am-9";
export var md = "_am-8";
export var redoButtonTabGroup = "_am-0";
export var sm = "_am-7";
export var tabButton = "_am-4";
export var tabButtonsContainer = "_am-2";
export var xs = "_am-5";